import React from 'react';
import { Link } from 'react-router-dom';
import { ARWMButton } from '../components/ARWMButton';
import { Card, CardHeader, CardTitle, CardContent } from '../components/Card';
import { Calendar } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Home() {
  useSEO('ARWM - Association des Restaurateurs de la Wilaya de Marrakech | Gastronomie Marrakech', "ARWM rassemble les meilleurs restaurants de Marrakech. Découvrez l'excellence gastronomique marocaine et rejoignez notre communauté de restaurateurs professionnels.");
  return <div className="w-full" data-id="element-430">
      {/* Hero Section */}
      <section className="relative min-h-screen bg-arwm-maroon flex items-center px-4 py-20" data-id="element-431">
        <div className="max-w-[1280px] mx-auto w-full" data-id="element-432">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-433">
            {/* Left Content */}
            <div className="text-left" data-id="element-434">
              <p className="font-josefin text-arwm-cream text-sm uppercase tracking-[4px] mb-4" data-id="element-435">
                Une Alliance Gourmande
              </p>
              <div className="text-arwm-cream text-2xl mb-6" data-id="element-436">◆</div>
              <h1 className="font-cormorant text-[60px] lg:text-[75px] font-bold text-white leading-tight mb-6" data-id="element-437">
                Promouvoir,
                <br data-id="element-438" />
                Partager
                <br data-id="element-439" />
                Célébrer
              </h1>
              <p className="font-josefin text-arwm-cream text-lg mb-12 leading-relaxed max-w-xl" data-id="element-440">
                Unis pour l'excellence gastronomique de Marrakech. Promouvons,
                partageons, célébrons la passion culinaire.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-441">
                <Link to="/a-propos" data-id="element-442">
                  <ARWMButton data-id="element-443">Découvrir</ARWMButton>
                </Link>
                <Link to="/adherents" data-id="element-444">
                  <ARWMButton variant="secondary" data-id="element-445">En savoir plus</ARWMButton>
                </Link>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative" data-id="element-446">
              <img src="https://cdn.magicpatterns.com/uploads/majqsauxgddXdPyzPUkZsj/65afa4f8df8d41eb86fe596b_95894103_2528269880731280_213791892763049984_n-p-1600.webp" alt="Architecture traditionnelle marocaine à Marrakech" className="w-full h-auto object-cover shadow-2xl" data-id="element-447" />
            </div>
          </div>
        </div>
      </section>

      {/* GO SIYAHA Banner */}
      <section className="bg-arwm-light-gray py-20 px-4" data-id="element-448">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-449">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4" data-id="element-450">
            Initiative Tourisme
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-6" data-id="element-451">
            GO SIYAHA
          </h2>
          <p className="font-josefin text-arwm-dark-text text-lg mb-8 max-w-2xl mx-auto" data-id="element-452">
            Participez à notre initiative pour promouvoir le tourisme
            gastronomique à Marrakech
          </p>
          <ARWMButton data-id="element-453">Accéder au formulaire</ARWMButton>
        </div>
      </section>

      {/* JOIGNEZ-VOUS Section */}
      <section className="relative py-32 px-4 bg-cover bg-center" style={{
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(https://images.unsplash.com/photo-1597212618440-806262de4f6b?w=1600)'
    }} data-id="element-454">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-455">
          <p className="font-josefin text-arwm-cream text-sm uppercase tracking-[3.2px] mb-4" data-id="element-456">
            Joignez-vous à l'ARWM
          </p>
          <div className="text-arwm-cream text-xl mb-6" data-id="element-457">— ◆ —</div>
          <h2 className="font-cormorant text-[52px] font-bold text-white mb-6 leading-tight max-w-4xl mx-auto" data-id="element-458">
            Ne manquez pas l'occasion unique de faire partie de l'ARWM!
          </h2>
          <p className="font-josefin text-arwm-cream text-lg mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-459">
            Rejoignez l'Association des Restaurateurs de la Wilaya de Marrakech
            et participez à l'excellence gastronomique de notre ville
          </p>
          <Link to="/adherents" data-id="element-460">
            <ARWMButton data-id="element-461">Adhérer</ARWMButton>
          </Link>
        </div>
      </section>

      {/* Events Section */}
      <section className="py-20 px-4 bg-white" data-id="element-462">
        <div className="max-w-[1280px] mx-auto" data-id="element-463">
          <div className="text-center mb-12" data-id="element-464">
            <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4" data-id="element-465">
              Agenda
            </p>
            <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-4" data-id="element-466">
              Événements
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-467">
            <Card data-id="element-468">
              <CardHeader data-id="element-469">
                <div className="flex items-center text-arwm-maroon mb-2" data-id="element-470">
                  <Calendar className="w-5 h-5 mr-2" data-id="element-471" />
                  <span className="font-josefin text-sm" data-id="element-472">15 Janvier 2025</span>
                </div>
                <CardTitle className="font-cormorant text-2xl" data-id="element-473">
                  Rencontre avec le Wali
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-474">
                <p className="font-josefin text-arwm-dark-text" data-id="element-475">
                  Rencontre importante avec le Wali de Marrakech pour discuter
                  des enjeux du secteur de la restauration.
                </p>
                <Link to="/events" className="inline-block mt-4" data-id="element-476">
                  <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-477">
                    En savoir plus →
                  </span>
                </Link>
              </CardContent>
            </Card>

            <Card data-id="element-478">
              <CardHeader data-id="element-479">
                <div className="flex items-center text-arwm-maroon mb-2" data-id="element-480">
                  <Calendar className="w-5 h-5 mr-2" data-id="element-481" />
                  <span className="font-josefin text-sm" data-id="element-482">22 Janvier 2025</span>
                </div>
                <CardTitle className="font-cormorant text-2xl" data-id="element-483">
                  Réunion Tourisme
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-484">
                <p className="font-josefin text-arwm-dark-text" data-id="element-485">
                  Réunion stratégique sur le développement du tourisme
                  gastronomique à Marrakech.
                </p>
                <Link to="/events" className="inline-block mt-4" data-id="element-486">
                  <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-487">
                    En savoir plus →
                  </span>
                </Link>
              </CardContent>
            </Card>

            <Card data-id="element-488">
              <CardHeader data-id="element-489">
                <div className="flex items-center text-arwm-maroon mb-2" data-id="element-490">
                  <Calendar className="w-5 h-5 mr-2" data-id="element-491" />
                  <span className="font-josefin text-sm" data-id="element-492">5 Février 2025</span>
                </div>
                <CardTitle className="font-cormorant text-2xl" data-id="element-493">
                  Formation Hygiène
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-494">
                <p className="font-josefin text-arwm-dark-text" data-id="element-495">
                  Formation obligatoire sur les normes d'hygiène et de sécurité
                  alimentaire pour les établissements membres.
                </p>
                <Link to="/events" className="inline-block mt-4" data-id="element-496">
                  <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-497">
                    En savoir plus →
                  </span>
                </Link>
              </CardContent>
            </Card>
          </div>
          <div className="text-center mt-12" data-id="element-498">
            <Link to="/events" data-id="element-499">
              <ARWMButton variant="secondary" data-id="element-500">
                Voir tous les événements
              </ARWMButton>
            </Link>
          </div>
        </div>
      </section>

      {/* Actualités Section */}
      <section className="py-20 px-4 bg-arwm-light-gray" data-id="element-501">
        <div className="max-w-[1280px] mx-auto" data-id="element-502">
          <div className="text-center mb-12" data-id="element-503">
            <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4" data-id="element-504">
              Notre Blog
            </p>
            <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-4" data-id="element-505">
              Actualités
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-506">
            <Card data-id="element-507">
              <CardHeader data-id="element-508">
                <div className="inline-block px-3 py-1 bg-arwm-maroon text-arwm-cream font-josefin text-xs uppercase tracking-wider mb-3" data-id="element-509">
                  Gastronomie
                </div>
                <CardTitle className="font-cormorant text-2xl" data-id="element-510">
                  Marrakech, Capitale de la Gastronomie Marocaine
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-511">
                <p className="font-josefin text-arwm-dark-text mb-4" data-id="element-512">
                  Découvrez comment Marrakech s'impose comme la destination
                  gastronomique incontournable du Maroc.
                </p>
                <Link to="/blog-posts/marrakech-capitale-gastronomie" data-id="element-513">
                  <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-514">
                    Lire la suite →
                  </span>
                </Link>
              </CardContent>
            </Card>

            <Card data-id="element-515">
              <CardHeader data-id="element-516">
                <div className="inline-block px-3 py-1 bg-arwm-maroon text-arwm-cream font-josefin text-xs uppercase tracking-wider mb-3" data-id="element-517">
                  Actualités
                </div>
                <CardTitle className="font-cormorant text-2xl" data-id="element-518">
                  Nouvelles Normes d'Hygiène 2025
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-519">
                <p className="font-josefin text-arwm-dark-text mb-4" data-id="element-520">
                  Point sur les nouvelles réglementations en matière d'hygiène
                  et de sécurité alimentaire.
                </p>
                <Link to="/blog-posts/nouvelles-normes-hygiene" data-id="element-521">
                  <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-522">
                    Lire la suite →
                  </span>
                </Link>
              </CardContent>
            </Card>

            <Card data-id="element-523">
              <CardHeader data-id="element-524">
                <div className="inline-block px-3 py-1 bg-arwm-maroon text-arwm-cream font-josefin text-xs uppercase tracking-wider mb-3" data-id="element-525">
                  Conseils
                </div>
                <CardTitle className="font-cormorant text-2xl" data-id="element-526">
                  10 Conseils pour Optimiser Votre Restaurant
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-527">
                <p className="font-josefin text-arwm-dark-text mb-4" data-id="element-528">
                  Des conseils pratiques pour améliorer la rentabilité et
                  l'efficacité de votre établissement.
                </p>
                <Link to="/blog-posts/conseils-gestion-restaurant" data-id="element-529">
                  <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-530">
                    Lire la suite →
                  </span>
                </Link>
              </CardContent>
            </Card>
          </div>
          <div className="text-center mt-12" data-id="element-531">
            <Link to="/blog" data-id="element-532">
              <ARWMButton variant="secondary" data-id="element-533">
                Voir toutes les actualités
              </ARWMButton>
            </Link>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-20 px-4 bg-white" data-id="element-534">
        <div className="max-w-[1280px] mx-auto" data-id="element-535">
          <div className="text-center mb-12" data-id="element-536">
            <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4" data-id="element-537">
              Ils nous soutiennent
            </p>
            <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-4" data-id="element-538">
              Nos Partenaires
            </h2>
          </div>
          <div className="relative overflow-hidden" data-id="element-539">
            <div className="flex gap-12 items-center animate-scroll" data-id="element-540">
              {/* First set of logos */}
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-541">
                <img src="https://cdn.magicpatterns.com/uploads/csZPVAGF8mfrzJq76whMxd/fnrt.png" alt="FNRT - Fédération Nationale de la Restauration et du Tourisme" className="max-h-20 w-auto object-contain" data-id="element-542" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-543">
                <img src="https://cdn.magicpatterns.com/uploads/gnYTSY6oCn2mr7HaTK2WHG/2024-11-13-191016.118455logo-crt-noirPlan-de-travail-1.png" alt="CRT - Conseil Régional du Tourisme Marrakech-Safi" className="max-h-28 w-auto object-contain" data-id="element-544" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-545">
                <img src="https://cdn.magicpatterns.com/uploads/t3MpF3QaHjrc5AwxJEjWQp/Logo_onmt_VF.png" alt="ONMT - Office National Marocain du Tourisme" className="max-h-14 w-auto object-contain" data-id="element-546" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-547">
                <img src="https://cdn.magicpatterns.com/uploads/jxShNXpZNbFufuoVpaniAM/images.png" alt="CNT - Confédération Nationale du Tourisme" className="max-h-24 w-auto object-contain" data-id="element-548" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-549">
                <img src="https://cdn.magicpatterns.com/uploads/bbpJykRagsoognhmy6vQTS/logo_ministere_fr_dark-1.png" alt="Ministère du Tourisme, de l'Artisanat et de l'Économie Sociale et Solidaire" className="max-h-20 w-auto object-contain" data-id="element-550" />
              </div>

              {/* Duplicate set for seamless loop */}
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-551">
                <img src="https://cdn.magicpatterns.com/uploads/csZPVAGF8mfrzJq76whMxd/fnrt.png" alt="FNRT" className="max-h-20 w-auto object-contain" data-id="element-552" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-553">
                <img src="https://cdn.magicpatterns.com/uploads/gnYTSY6oCn2mr7HaTK2WHG/2024-11-13-191016.118455logo-crt-noirPlan-de-travail-1.png" alt="CRT" className="max-h-28 w-auto object-contain" data-id="element-554" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-555">
                <img src="https://cdn.magicpatterns.com/uploads/t3MpF3QaHjrc5AwxJEjWQp/Logo_onmt_VF.png" alt="ONMT" className="max-h-14 w-auto object-contain" data-id="element-556" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-557">
                <img src="https://cdn.magicpatterns.com/uploads/jxShNXpZNbFufuoVpaniAM/images.png" alt="CNT" className="max-h-24 w-auto object-contain" data-id="element-558" />
              </div>
              <div className="flex items-center justify-center min-w-[200px] h-32" data-id="element-559">
                <img src="https://cdn.magicpatterns.com/uploads/bbpJykRagsoognhmy6vQTS/logo_ministere_fr_dark-1.png" alt="Ministère" className="max-h-20 w-auto object-contain" data-id="element-560" />
              </div>
            </div>
          </div>

          <style jsx data-id="element-561">{`
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-50%);
              }
            }

            .animate-scroll {
              animation: scroll 30s linear infinite;
            }

            .animate-scroll:hover {
              animation-play-state: paused;
            }
          `}</style>
        </div>
      </section>
    </div>;
}